import { lt } from '@mews/framework';
import { Button, IconName, TableHeader } from '@optimus-web/core';
import { useCashierCloseShiftDialog } from '../modals/shiftClose/useCashierCloseShiftDialog';
import { ShiftOverviewTable } from '../tables/ShiftOverviewTable';
import { CashierShiftProps } from '../../types';

export const ShiftOverviewSection = ({ cashierId, shiftId }: CashierShiftProps) => {
    const showCloseShift = !!cashierId && !shiftId;
    const [renderDialog, toggleDialog] = useCashierCloseShiftDialog(cashierId || '');
    return (
        <>
            <TableHeader
                title={lt('CashierShiftOverview')}
                rightSide={
                    showCloseShift ? (
                        <Button
                            size="small"
                            icon={IconName.CheckCircle}
                            onClick={toggleDialog}
                            variant="primary"
                            type="button"
                        >
                            {lt('CashierShiftClose')}
                        </Button>
                    ) : null
                }
            />
            <ShiftOverviewTable cashierId={cashierId} shiftId={shiftId} />
            {renderDialog()}
        </>
    );
};
